var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "el-form-title",
          attrs: { model: _vm.form, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "任务资源库名称" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入需要查询的任务资源库名称" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c("el-form-item", [
            _c(
              "div",
              { staticClass: "align-right" },
              [
                _c("el-button", { on: { click: _vm.fetchData } }, [
                  _vm._v("查询"),
                ]),
                _c("el-button", { on: { click: _vm.addStory } }, [
                  _vm._v("新增"),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading",
            height: "48",
            border: "",
            "header-cell-style": { background: "rgb(244 244 244)" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "任务资源库名称",
              "min-width": "180",
              fixed: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.name) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "任务状态", "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.status_desc) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "问题数量", "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(" " + _vm._s(scope.row.questionNum || 0) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "创建时间", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.createTime))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "更新时间", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.updateTime))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "描述", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.description || "暂无")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "操作",
              "min-width": "350",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status !== "1"
                      ? _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.delItem(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.editItem(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    scope.row.status === "4"
                      ? _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.reason(scope.row)
                              },
                            },
                          },
                          [_vm._v("失败原因")]
                        )
                      : _vm._e(),
                    _vm.canReExecute(scope.row)
                      ? _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.reExecute(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("再次执行")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }